import { z } from "zod";
const mastraValidationErrorSchema = z.object({
  error: z.literal(true),
  message: z.string(),
  validationErrors: z.any()
});
const mastraErrorJsonSchema = z.object({
  message: z.string(),
  domain: z.string(),
  category: z.string()
});
const mastraErrorOutputSchema = z.union([
  mastraValidationErrorSchema,
  mastraErrorJsonSchema
]);
function checkIsMastraErrorToolOutput(value) {
  return mastraErrorOutputSchema.safeParse(value).success;
}
export {
  checkIsMastraErrorToolOutput,
  mastraErrorOutputSchema
};
//# sourceMappingURL=mastraErrorToolOutput.js.map
